import React, { useState, useEffect, useCallback } from 'react';
import { rolesApi } from '../../services/api';
import { useT } from '../../i18n';
import toast from 'react-hot-toast';

// Bütün mümkün sistem funksiyaları — A-dan Z-yə (tam genişləndirilmiş)
const ALL_PERMISSIONS = {
  barriers: {
    label: 'Şlaqbaumlar',
    icon: '⊞',
    actions: {
      view:         'Siyahıya baxış',
      open:         'İnternet ilə aç (relay)',
      bluetooth:    'Bluetooth (BLE) token ilə aç',
      manage:       'Yarat / sil / konfiqurasiya et',
      logs:         'Giriş loglarına bax',
      users:        'İstifadəçiləri idarə et (əlavə/sil)',
      guest_qr:     'Qonaq QR kodu yarat',
      ota:          'OTA firmware yükləmə',
      status:       'Cihaz statusunu izlə (heartbeat)',
    },
  },
  restaurants: {
    label: 'Restoranlar',
    icon: '◉',
    actions: {
      view:         'Restoran siyahısına bax',
      manage:       'Restoran yarat / redaktə / sil',
      menu_view:    'Menyuya bax',
      menu_manage:  'Menyu əlavə/dəyiş/sil (kateqoriya & element)',
      tables:       'Masa yarat / QR kod al',
      gallery:      'Şəkil/qalereya idarəetməsi',
      orders_view:  'Sifarişlərə bax (siyahı)',
      orders_edit:  'Sifariş statusunu dəyiş',
      orders_cancel:'Sifarişi ləğv et',
      costs:        'Xərc məlumatlarına bax',
    },
  },
  kitchen: {
    label: 'Mətbəx & Ofisiant',
    icon: '🍳',
    actions: {
      kitchen_view: 'Mətbəx ekranını gör (aktiv sifarişlər)',
      status_update:'Sifariş statusunu yenilə (Hazır/Çatdırıldı)',
      waiter_call:  'Ofisiant çağırışlarını gör',
      revenue:      'Gündəlik gəlirə bax',
      reports:      'Mətbəx hesabatları',
    },
  },
  portal: {
    label: 'Restoran Portalı',
    icon: '🌐',
    actions: {
      login:        'Portala giriş (restoran işçisi)',
      settings:     'Portal parametrləri (logo/ad/məlumat)',
      categories:   'Kateqoriyaları idarə et',
      items:        'Menyu elementlərini idarə et',
      availability: 'Elementin mövcudluğunu aç/bağla',
      gallery:      'Qalereya şəkillərini idarə et',
    },
  },
  wallet: {
    label: 'Wallet & Ödəniş',
    icon: '◆',
    actions: {
      view:         'Balansa bax',
      transactions: 'Əməliyyat tarixçəsini gör',
      topup:        'Balans artır (müştəri adından)',
      refund:       'Geri qaytarma (refund)',
      manage:       'Admin əməliyyatları (hər kəs adından)',
      payment_gw:   'Ödəniş şlüzü konfiqurasiyası',
      subscription: 'Abunəlik idarəetməsi',
    },
  },
  delivery: {
    label: 'Çatdırılma',
    icon: '📦',
    actions: {
      view:         'Çatdırılma sifarişlərinə bax',
      manage:       'Sifariş yarat / redaktə',
      assign:       'Kuryer təyin et',
      track:        'Kuryer izlə (real-time)',
      reports:      'Çatdırılma hesabatları',
    },
  },
  taxi: {
    label: 'Taxi',
    icon: '🚕',
    actions: {
      view:         'Sürücülərə bax',
      manage:       'Sürücü yarat / sil',
      trips:        'Gediş tarixçəsi',
      pricing:      'Qiymət idarəetməsi',
      reports:      'Taxi hesabatları',
    },
  },
  announcements: {
    label: 'Elanlar & Xəbərlər',
    icon: '📢',
    actions: {
      view:         'Elanlara bax',
      create:       'Elan yarat',
      edit:         'Elanı redaktə et',
      delete:       'Elanı sil',
      publish:      'Yayımla / arxivlə',
      pin:          'Elanı sab et (pin)',
    },
  },
  notifications: {
    label: 'Bildirişlər',
    icon: '🔔',
    actions: {
      view:         'Bildiriş tarixçəsinə bax',
      send_push:    'Push bildirişi göndər (bütün/seçilmiş)',
      send_sms:     'SMS göndər',
      send_email:   'E-poçt göndər',
      templates:    'Bildiriş şablonlarını idarə et',
    },
  },
  users: {
    label: 'İstifadəçilər',
    icon: '◎',
    actions: {
      view:         'Siyahıya bax (müştəri & işçi)',
      create:       'Yeni hesab yarat',
      edit:         'Profil redaktə et',
      delete:       'Hesabı sil',
      block:        'Blokla / bloku aç',
      role_assign:  'Rol təyin et',
      reset_pass:   'Şifrəni sıfırla',
      view_private: 'Şəxsi məlumatları gör (telefon/email)',
    },
  },
  reports: {
    label: 'Hesabatlar',
    icon: '📊',
    actions: {
      view:         'Hesabatlara bax',
      export_csv:   'CSV kimi ixrac et',
      export_pdf:   'PDF kimi ixrac et',
      financial:    'Maliyyə hesabatları',
      staff:        'İşçi aktivlik hesabatları',
      audit:        'Audit log hesabatları',
    },
  },
  analytics: {
    label: 'Analitika & Dashboard',
    icon: '▲',
    actions: {
      view:         'Dashboard və qrafiklərə bax',
      realtime:     'Real-time monitordinq',
      export:       'Analitika ixrac',
      custom:       'Xüsusi sorğu & filter',
    },
  },
  settings: {
    label: 'Sistem Parametrləri',
    icon: '⚙',
    actions: {
      view:         'Parametrlərə bax',
      modules:      'Modulları aç/bağla',
      branding:     'Logo, ad, dizayn dəyiş',
      integrations: 'Xarici inteqrasiyalar (SMS/MQTT/bank)',
      sessions:     'Sessiya & vaxt idarəetməsi',
      backup:       'DB backup başlat',
      manage:       'Tam admin səlahiyyəti',
    },
  },
  roles: {
    label: 'Rol İdarəetməsi',
    icon: '⬡',
    actions: {
      view:         'Rollara bax',
      create:       'Yeni rol yarat',
      edit:         'Rolu redaktə et',
      delete:       'Rolu sil',
      assign:       'İstifadəçiyə rol təyin et',
    },
  },
};

const SESSION_TIMEOUT_OPTIONS = [
  { value: 0,        label: 'Limitsiz' },
  { value: 900,      label: '15 dəqiqə' },
  { value: 1800,     label: '30 dəqiqə' },
  { value: 3600,     label: '1 saat' },
  { value: 7200,     label: '2 saat' },
  { value: 14400,    label: '4 saat' },
  { value: 28800,    label: '8 saat' },
  { value: 86400,    label: '1 gün (24 saat)' },
  { value: 604800,   label: '7 gün' },
  { value: 2592000,  label: '30 gün' },
];

const DEFAULT_PERMS = Object.fromEntries(
  Object.entries(ALL_PERMISSIONS).map(([k, v]) => [
    k, Object.fromEntries(Object.keys(v.actions).map(a => [a, false]))
  ])
);

const ROLE_COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#ef4444', '#06b6d4', '#ec4899', '#14b8a6'];
const ROLE_ICONS = ['⬡', '★', '◉', '⊞', '◆', '▲', '◎', '⚙'];

function Toggle({ checked, onChange }) {
  return (
    <button type="button" onClick={() => onChange(!checked)}
      style={{ width: 40, height: 22, borderRadius: 11, border: 'none', cursor: 'pointer', background: checked ? 'var(--primary)' : 'var(--border)', position: 'relative', transition: 'background 0.2s', flexShrink: 0 }}>
      <div style={{ position: 'absolute', top: 3, left: checked ? 21 : 3, width: 16, height: 16, borderRadius: '50%', background: 'white', transition: 'left 0.2s' }} />
    </button>
  );
}

function RoleCard({ role, selected, onClick, onDelete }) {
  return (
    <div style={{ ...S.roleCard, borderColor: selected ? (role.color || 'var(--primary)') : 'var(--border)', background: selected ? (role.color || 'var(--primary)') + '11' : 'var(--card)' }}
      onClick={onClick}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <div style={{ ...S.roleIcon, background: (role.color || 'var(--primary)') + '22', color: role.color || 'var(--primary)' }}>
          {role.icon || '⬡'}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text)', marginBottom: 3 }}>{role.name}</div>
          {role.description && <div style={{ fontSize: 12, color: 'var(--text3)', lineHeight: 1.4 }}>{role.description}</div>}
          <div style={{ marginTop: 6, fontSize: 11, color: 'var(--text3)' }}>
            {Object.entries(role.permissions || {})
              .filter(([, v]) => Object.values(v).some(Boolean))
              .map(([k]) => ALL_PERMISSIONS[k]?.label || k)
              .join(' · ') || 'İcazə yoxdur'}
          </div>
        </div>
      </div>
      {!role.isSystem && (
        <button style={S.deleteRoleBtn} onClick={e => { e.stopPropagation(); onDelete(role); }}>🗑</button>
      )}
    </div>
  );
}

export default function Roles() {
  const t = useT();
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [showCreate, setShowCreate] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({
    name: '',
    description: '',
    color: '#3b82f6',
    icon: '⬡',
    sessionTimeout: 0,
    permissions: JSON.parse(JSON.stringify(DEFAULT_PERMS)),
  });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await rolesApi.list();
      setRoles(Array.isArray(data) ? data : []);
    } catch { toast.error('Yüklənmədi'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const openRole = (role) => {
    setSelected(role);
    setForm({
      name: role.name,
      description: role.description || '',
      color: role.color || '#3b82f6',
      icon: role.icon || '⬡',
      sessionTimeout: role.sessionTimeout ?? 0,
      permissions: JSON.parse(JSON.stringify(
        Object.fromEntries(Object.keys(DEFAULT_PERMS).map(sec => [
          sec, { ...DEFAULT_PERMS[sec], ...(role.permissions?.[sec] || {}) }
        ]))
      )),
    });
    setShowCreate(false);
  };

  const startCreate = () => {
    setSelected(null);
    setForm({ name: '', description: '', color: '#3b82f6', icon: '⬡', sessionTimeout: 0, permissions: JSON.parse(JSON.stringify(DEFAULT_PERMS)) });
    setShowCreate(true);
  };

  const handleSave = async (e) => {
    e?.preventDefault();
    if (!form.name.trim()) { toast.error('Rol adı məcburidir'); return; }
    setSaving(true);
    try {
      if (selected) {
        const updated = await rolesApi.update(selected.id, form);
        setRoles(prev => prev.map(r => r.id === selected.id ? updated : r));
        setSelected(updated);
        toast.success('Rol yeniləndi!');
      } else {
        const created = await rolesApi.create(form);
        setRoles(prev => [...prev, created]);
        setSelected(created);
        setShowCreate(false);
        toast.success('Rol yaradıldı!');
      }
    } catch (e) { toast.error(e?.message || 'Xəta'); }
    finally { setSaving(false); }
  };

  const handleDelete = async (role) => {
    try {
      await rolesApi.remove(role.id);
      setRoles(prev => prev.filter(r => r.id !== role.id));
      if (selected?.id === role.id) setSelected(null);
      setConfirmDelete(null);
      toast.success('Rol silindi');
    } catch (e) { toast.error(e?.message || 'Xəta'); }
  };

  const togglePerm = (section, action) => {
    setForm(prev => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [section]: { ...prev.permissions[section], [action]: !prev.permissions[section]?.[action] },
      },
    }));
  };

  const toggleSection = (section) => {
    const all = Object.values(form.permissions[section] || {}).every(Boolean);
    const actions = Object.keys(ALL_PERMISSIONS[section].actions);
    setForm(prev => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [section]: Object.fromEntries(actions.map(a => [a, !all])),
      },
    }));
  };

  const isShowingForm = showCreate || (selected && !selected.isSystem);

  return (
    <div>
      {/* Header */}
      <div style={S.header}>
        <div>
          <h1 style={{ ...S.title, color: 'var(--text)' }}>{t('roles_title')}</h1>
          <p style={{ ...S.sub, color: 'var(--text3)' }}>{t('roles_sub')}</p>
        </div>
        <button style={S.createBtn} onClick={startCreate}>{t('roles_create')}</button>
      </div>

      <div style={S.layout}>
        {/* Sol: rol siyahısı */}
        <div style={S.roleList}>
          {loading ? <div style={{ color: 'var(--text3)', padding: 20 }}>Yüklənir...</div>
            : roles.length === 0 ? <div style={{ color: 'var(--text3)', padding: 20 }}>Rol yoxdur</div>
            : roles.map(r => (
              <RoleCard key={r.id} role={r}
                selected={selected?.id === r.id || (showCreate && !selected)}
                onClick={() => openRole(r)}
                onDelete={r => setConfirmDelete(r)} />
            ))
          }

          {/* Yeni rol kartı placeholder */}
          {showCreate && (
            <div style={{ ...S.roleCard, borderColor: 'var(--primary)', borderStyle: 'dashed', background: 'var(--primary)08' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ ...S.roleIcon, background: 'var(--primary)22', color: 'var(--primary)' }}>+</div>
                <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--primary)' }}>Yeni Rol...</div>
              </div>
            </div>
          )}
        </div>

        {/* Sağ: form */}
        {isShowingForm && (
          <div style={{ ...S.formPanel, background: 'var(--card)', borderColor: 'var(--border)' }}>
            <form onSubmit={handleSave}>
              <div style={{ ...S.formTitle, color: 'var(--text)' }}>{selected ? selected.name : t('roles_create')}</div>

              {/* Əsas məlumat */}
              <div style={S.formGrid}>
                <div style={{ gridColumn: '1/-1' }}>
                  <div style={S.fieldLabel}>{t('roles_name')} *</div>
                  <input style={S.inp} value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Menecer, Kassir, Mühafizəçi..." />
                </div>
                <div style={{ gridColumn: '1/-1' }}>
                  <div style={S.fieldLabel}>{t('roles_desc')}</div>
                  <input style={S.inp} value={form.description} onChange={e => setForm({...form, description: e.target.value})} placeholder="Bu rolun vəzifəsi..." />
                </div>

                {/* Icon seçim */}
                <div>
                  <div style={S.fieldLabel}>İkon</div>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    {ROLE_ICONS.map(ic => (
                      <button key={ic} type="button"
                        style={{ width: 36, height: 36, borderRadius: 8, border: `2px solid ${form.icon === ic ? 'var(--primary)' : 'var(--border)'}`, background: form.icon === ic ? 'var(--primary)22' : 'var(--bg2)', fontSize: 18, cursor: 'pointer' }}
                        onClick={() => setForm({...form, icon: ic})}>{ic}</button>
                    ))}
                  </div>
                </div>

                {/* Rəng seçim */}
                <div>
                  <div style={S.fieldLabel}>Rəng</div>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    {ROLE_COLORS.map(c => (
                      <button key={c} type="button"
                        style={{ width: 30, height: 30, borderRadius: '50%', background: c, border: `3px solid ${form.color === c ? 'white' : 'transparent'}`, cursor: 'pointer', outline: form.color === c ? `2px solid ${c}` : 'none' }}
                        onClick={() => setForm({...form, color: c})} />
                    ))}
                  </div>
                </div>
              </div>

              {/* Sessiya vaxtı */}
              <div style={{ marginTop: 20 }}>
                <div style={S.sectionTitle}>Sessiya & Çıxış Vaxtı</div>
                <p style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 10 }}>Bu rol üçün avtomatik logout müddəti</p>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {SESSION_TIMEOUT_OPTIONS.map(opt => (
                    <button key={opt.value} type="button"
                      onClick={() => setForm({ ...form, sessionTimeout: opt.value })}
                      style={{
                        padding: '7px 14px', borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: 'pointer',
                        border: `2px solid ${form.sessionTimeout === opt.value ? 'var(--primary)' : 'var(--border)'}`,
                        background: form.sessionTimeout === opt.value ? 'var(--primary)' : 'var(--bg2)',
                        color: form.sessionTimeout === opt.value ? 'white' : 'var(--text2)',
                        transition: 'all 0.15s',
                      }}>
                      {opt.value === 0 ? '∞ ' : ''}{opt.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* İcazələr — A-dan Z-yə */}
              <div style={{ marginTop: 20 }}>
                <div style={S.sectionTitle}>{t('roles_perms')}</div>
                <p style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 14 }}>Rol üçün lazım olan funksiyaları aşağıdan seçin</p>

                {Object.entries(ALL_PERMISSIONS).map(([section, meta]) => {
                  const perms = form.permissions[section] || {};
                  const allOn = Object.keys(meta.actions).every(a => perms[a]);
                  return (
                    <div key={section} style={{ ...S.permSection, borderColor: 'var(--border)' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span style={{ fontSize: 18 }}>{meta.icon}</span>
                          <span style={{ fontSize: 14, fontWeight: 700, color: 'var(--text)' }}>{meta.label}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span style={{ fontSize: 11, color: 'var(--text3)' }}>{allOn ? 'Hamısı' : 'Seçili'}</span>
                          <Toggle checked={allOn} onChange={() => toggleSection(section)} />
                        </div>
                      </div>

                      <div style={S.actionGrid}>
                        {Object.entries(meta.actions).map(([action, desc]) => {
                          const on = perms[action] || false;
                          return (
                            <div key={action} style={{ ...S.actionItem, borderColor: on ? 'var(--primary)44' : 'var(--border)', background: on ? 'var(--primary)0d' : 'var(--bg2)' }}
                              onClick={() => togglePerm(section, action)}>
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div>
                                  <div style={{ fontSize: 12, fontWeight: 700, color: on ? 'var(--primary)' : 'var(--text)', textTransform: 'capitalize' }}>{action}</div>
                                  <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 2, lineHeight: 1.3 }}>{desc}</div>
                                </div>
                                <div style={{ width: 18, height: 18, borderRadius: '50%', background: on ? 'var(--primary)' : 'var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                  {on && <span style={{ color: 'white', fontSize: 10, fontWeight: 700 }}>✓</span>}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>

              <button style={S.submitBtn} type="submit" disabled={saving}>
                {saving ? '⟳ Saxlanılır...' : `✓ ${t('roles_save')}`}
              </button>
            </form>
          </div>
        )}

        {/* Sistem rolu baxışı */}
        {selected?.isSystem && (
          <div style={{ ...S.formPanel, background: 'var(--card)', borderColor: 'var(--border)' }}>
            <div style={{ ...S.formTitle, color: 'var(--text)' }}>{selected.name}</div>
            <div style={{ padding: '12px 16px', background: 'var(--warning)18', border: '1px solid var(--warning)44', borderRadius: 10, color: 'var(--warning)', fontSize: 13, marginBottom: 16 }}>
              ⚠️ Bu sistem roludur — sistem rolları redaktə edilə bilməz.
            </div>
            {Object.entries(ALL_PERMISSIONS).map(([section, meta]) => {
              const perms = selected.permissions?.[section] || {};
              const activeActions = Object.entries(perms).filter(([, v]) => v);
              if (!activeActions.length) return null;
              return (
                <div key={section} style={{ marginBottom: 12 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text2)', marginBottom: 6 }}>{meta.icon} {meta.label}</div>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    {activeActions.map(([a]) => (
                      <span key={a} style={{ fontSize: 11, padding: '3px 10px', background: 'var(--primary)22', color: 'var(--primary)', borderRadius: 20 }}>{a}</span>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Delete confirm */}
      {confirmDelete && (
        <div style={S.modal} onClick={() => setConfirmDelete(null)}>
          <div style={{ ...S.modalBox, background: 'var(--card)', borderColor: 'var(--border)' }} onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: 36, textAlign: 'center', marginBottom: 12 }}>🗑</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--text)', textAlign: 'center', marginBottom: 8 }}>{t('confirm_delete')}</div>
            <div style={{ fontSize: 13, color: 'var(--text3)', textAlign: 'center', marginBottom: 20 }}>«{confirmDelete.name}» rolu</div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button style={{ ...S.submitBtn, flex: 1, margin: 0, background: 'var(--danger)' }} onClick={() => handleDelete(confirmDelete)}>{t('yes')}, Sil</button>
              <button style={{ flex: 1, padding: '10px', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 8, color: 'var(--text)', cursor: 'pointer' }} onClick={() => setConfirmDelete(null)}>{t('cancel')}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const S = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 },
  title: { fontSize: 24, fontWeight: 800, marginBottom: 4 },
  sub: { fontSize: 13 },
  createBtn: { padding: '10px 20px', background: 'var(--primary)', color: 'white', border: 'none', borderRadius: 10, fontWeight: 700, fontSize: 13, cursor: 'pointer' },
  layout: { display: 'grid', gridTemplateColumns: '320px 1fr', gap: 20, alignItems: 'start' },
  roleList: { display: 'flex', flexDirection: 'column', gap: 8 },
  roleCard: { background: 'var(--card)', border: '1px solid', borderRadius: 12, padding: 14, cursor: 'pointer', transition: 'all 0.2s', position: 'relative' },
  roleIcon: { width: 40, height: 40, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 },
  deleteRoleBtn: { position: 'absolute', top: 10, right: 10, background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 7, padding: '3px 7px', fontSize: 14, cursor: 'pointer' },
  formPanel: { border: '1px solid', borderRadius: 14, padding: 24, maxHeight: 'calc(100vh - 120px)', overflowY: 'auto' },
  formTitle: { fontSize: 18, fontWeight: 800, marginBottom: 18 },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 },
  fieldLabel: { fontSize: 11, color: 'var(--text3)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 5 },
  inp: { width: '100%', padding: '9px 12px', background: 'var(--input-bg, var(--bg2))', border: '1px solid var(--border)', borderRadius: 8, color: 'var(--text)', fontSize: 13, outline: 'none' },
  sectionTitle: { fontSize: 13, fontWeight: 700, color: 'var(--text2)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 6 },
  permSection: { border: '1px solid', borderRadius: 12, padding: 16, marginBottom: 12 },
  actionGrid: { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 8 },
  actionItem: { border: '1px solid', borderRadius: 8, padding: '10px 12px', cursor: 'pointer', transition: 'all 0.18s' },
  submitBtn: { marginTop: 20, width: '100%', padding: '12px', background: 'var(--primary)', color: 'white', border: 'none', borderRadius: 10, fontWeight: 700, fontSize: 14, cursor: 'pointer' },
  modal: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999, backdropFilter: 'blur(4px)' },
  modalBox: { borderRadius: 16, padding: 28, border: '1px solid', width: 360 },
};
